/**
 * 18 Oct 2026 (D-1018-VOL): the card's older address, `/volunteers?v=<VolunteerID>[&signup=1]`, lands on the
 * volunteer's own page. Decided here, before the Volunteers list's chunk is loaded, so an old link (Reports, the
 * calendar, Today's items, an email the office kept) opens the page in one hop; without `v`, the list renders.
 */
import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export function VolunteerCardRedirect({ children }: { children: ReactNode }) {
  const [params] = useSearchParams();
  const v = params.get('v');
  if (v) return <Navigate to={`/volunteers/${encodeURIComponent(v)}${params.get('signup') === '1' ? '?signup=1' : ''}`} replace />;
  return <>{children}</>;
}
